(function () {
  const root = document.getElementById("jod-tailor-root");
  if (!root) return;

  const backendUrl = (root.dataset.backendUrl || "").replace(/\/$/, "");
  const productHandle = root.dataset.productHandle || "custom-leather-jacket";

  const $hero = root.querySelector('[data-jod-screen="hero"]');
  const $fitting = root.querySelector('[data-jod-screen="fitting"]');
  const $log = root.querySelector("[data-jod-log]");
  const $composer = root.querySelector("[data-jod-composer]");
  const $input = root.querySelector("[data-jod-input]");
  const $upload = root.querySelector("[data-jod-upload]");
  const $specList = root.querySelector("[data-jod-spec]");
  const $specPlaceholder = root.querySelector("[data-jod-spec-placeholder]");
  const $mockupStack = root.querySelector("[data-jod-mockup-stack]");
  const $addToCart = root.querySelector('[data-jod-action="add-to-cart"]');
  const $openMeasure = root.querySelector('[data-jod-action="open-measurements"]');
  const $linkToggle = root.querySelector("[data-jod-link-toggle]");
  const $linkPopover = root.querySelector("[data-jod-link-popover]");
  const $linkInput = root.querySelector("[data-jod-link-input]");
  const $linkSubmit = root.querySelector("[data-jod-link-submit]");
  const $linkError = root.querySelector("[data-jod-link-error]");
  const $whatsapp = root.querySelector('[data-jod-action="open-whatsapp"]');

  const SPEC_FIELDS = [
    { key: "style",    label: "Style"    },
    { key: "material", label: "Material" },
    { key: "color",    label: "Color"    },
    { key: "collar",   label: "Collar"   },
    { key: "lining",   label: "Lining"   },
    { key: "hardware", label: "Hardware" },
    { key: "length",   label: "Length"   },
    { key: "details",  label: "Details"  },
    { key: "size",     label: "Size"     },
    { key: "measurements", label: "Measurements" },
  ];

  const state = {
    history: [],
    spec: {},
    mockupUrl: null,
    referenceImage: null,
  };

  // ---- screen transitions ----
  root.querySelector('[data-jod-action="begin"]').addEventListener("click", () => {
    $hero.hidden = true;
    $fitting.hidden = false;
    setTimeout(() => {
      tailorSay(
        "Welcome. I'm your tailor at Jacket on Demand. " +
        "Tell me — what kind of jacket are you imagining today? " +
        "A classic leather biker, a varsity, something you saw online?"
      );
    }, 350);
    $input.focus();
  });

  // ---- composer ----
  $composer.addEventListener("submit", (e) => {
    e.preventDefault();
    const text = $input.value.trim();
    if (!text && !state.referenceImage) return;
    sendUserMessage(text, state.referenceImage);
    $input.value = "";
    state.referenceImage = null;
  });

  $upload.addEventListener("change", async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    const dataUrl = await fileToDataUrl(file);
    state.referenceImage = dataUrl;
    userSay("(Reference image attached — ready to send.)", dataUrl);
  });

  // ---- paste-a-link popover ----
  function openLinkPopover() {
    $linkError.hidden = true;
    $linkInput.value = "";
    $linkPopover.hidden = false;
    setTimeout(() => $linkInput.focus(), 50);
  }
  function closeLinkPopover() {
    $linkPopover.hidden = true;
  }
  $linkToggle.addEventListener("click", () => {
    if ($linkPopover.hidden) openLinkPopover();
    else closeLinkPopover();
  });
  document.addEventListener("click", (e) => {
    if (
      !$linkPopover.hidden &&
      !$linkPopover.contains(e.target) &&
      !$linkToggle.contains(e.target)
    ) {
      closeLinkPopover();
    }
  });
  $linkInput.addEventListener("keydown", (e) => {
    if (e.key === "Enter") { e.preventDefault(); $linkSubmit.click(); }
    if (e.key === "Escape") closeLinkPopover();
  });

  $linkSubmit.addEventListener("click", async () => {
    const url = $linkInput.value.trim();
    if (!url) return;
    if (!/^https?:\/\//i.test(url)) {
      $linkError.textContent = "Please paste a full https link.";
      $linkError.hidden = false;
      return;
    }
    if (!backendUrl) {
      $linkError.textContent =
        "Pasting links needs the AI backend connected. Upload the image directly for now.";
      $linkError.hidden = false;
      return;
    }
    $linkSubmit.disabled = true;
    const originalLabel = $linkSubmit.textContent;
    $linkSubmit.textContent = "Fetching…";
    $linkError.hidden = true;
    try {
      const resp = await fetch(`${backendUrl}/api/fetch-image`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url }),
      });
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok) throw new Error(data.error || `Couldn't fetch (${resp.status}).`);
      state.referenceImage = data.image;
      userSay("(Reference link attached — ready to send.)", data.image);
      closeLinkPopover();
      $input.focus();
    } catch (err) {
      $linkError.textContent = err.message || "Couldn't fetch that link.";
      $linkError.hidden = false;
    } finally {
      $linkSubmit.disabled = false;
      $linkSubmit.textContent = originalLabel;
    }
  });

  // ---- send + receive ----
  async function sendUserMessage(text, image) {
    if (text || image) userSay(text || "(Image)", image && !state.referenceImage ? null : image);
    state.history.push({ role: "user", content: text, image });

    const $thinking = showTyping();

    try {
      const reply = backendUrl
        ? await callBackend(text, image)
        : await stubReply(text, image);

      $thinking.remove();
      if (reply.message) {
        tailorSay(reply.message);
        state.history.push({ role: "assistant", content: reply.message });
      }

      if (reply.spec)      updateSpec(reply.spec);
      if (reply.mockupUrl) setMockup(reply.mockupUrl);
      if (reply.action === "open_measurements") openMeasurements();
      maybeEnableCart();
    } catch (err) {
      $thinking.remove();
      tailorSay("Apologies — the line dropped for a moment. Could you say that again?");
      console.error("[tailor]", err);
    }
  }

  async function callBackend(text, image) {
    const res = await fetch(`${backendUrl}/api/chat`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        history: state.history,
        spec: state.spec,
        message: text,
        image,
      }),
    });
    if (!res.ok) throw new Error(`Backend ${res.status}`);
    return await res.json();
  }

  // ---- stub mode (no backend) ----
  async function stubReply(text, image) {
    await sleep(700 + Math.random() * 600);
    const turn = state.history.filter(m => m.role === "user").length;
    const lower = (text || "").toLowerCase();

    if (image) {
      return {
        message:
          "Lovely reference — I see a fitted silhouette, snap-down collar, two slanted pockets. " +
          "Shall we recreate this in lambskin or full-grain cowhide?",
        spec: { style: "Inspired by your reference", details: "Snap-down collar, slanted hand pockets" },
      };
    }

    if (turn === 1) {
      const style = /varsity/.test(lower) ? "Varsity" :
                    /bomber/.test(lower)  ? "Bomber"  :
                    /biker|moto/.test(lower) ? "Biker" :
                    /blazer/.test(lower)  ? "Blazer" : "Classic";
      return {
        message: `${style} — a strong choice. Are you leaning toward soft lambskin (drapes beautifully) or a heavier full-grain cowhide that ages with character?`,
        spec: { style },
      };
    }
    if (turn === 2) {
      const material = /lamb/.test(lower) ? "Lambskin" :
                       /cow|grain/.test(lower) ? "Full-grain cowhide" :
                       /suede/.test(lower) ? "Suede" : "Lambskin";
      return {
        message: `${material}, noted. And the color — keeping it timeless in black or cognac, or going somewhere bolder?`,
        spec: { material },
      };
    }
    if (turn === 3) {
      const color = /cognac|tan|brown/.test(lower) ? "Cognac" :
                    /black/.test(lower) ? "Black" :
                    /oxblood|burgundy|wine/.test(lower) ? "Oxblood" : "Black";
      return {
        message: `${color} — handsome. For the collar: classic lapel, snap-down, mandarin, or a shawl?`,
        spec: { color },
      };
    }
    if (turn === 4) {
      const collar = /lapel/.test(lower) ? "Notched lapel" :
                     /snap/.test(lower) ? "Snap-down" :
                     /mandarin/.test(lower) ? "Mandarin" :
                     /shawl/.test(lower) ? "Shawl" : "Notched lapel";
      return {
        message: `${collar}, perfect. Lining — silk-feel viscose for a luxurious slip, or quilted for warmth?`,
        spec: { collar },
      };
    }
    if (turn === 5) {
      return {
        message: "Beautiful. Let me sketch what we have so far.",
        spec: {
          lining: /quilt/.test(lower) ? "Quilted" : "Silk-feel viscose",
          hardware: "Antique brass",
          length: "Hip length",
          details: "Two slanted hand pockets, interior chest pocket",
        },
        mockupUrl: stubMockupUrl(),
      };
    }
    if (turn === 6) {
      return {
        message: "Lovely. Now — let's get the fit exactly right. Open the measurement guide and I'll walk you through it.",
        action: "open_measurements",
      };
    }
    return {
      message:
        "When you're ready, tap \"Add this jacket to cart\". Your atelier copy will reach our cutting room within the hour.",
    };
  }

  function stubMockupUrl() {
    return "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=800&q=80";
  }

  // ---- DOM helpers ----
  function tailorSay(text) {
    const el = document.createElement("div");
    el.className = "jod-msg jod-msg--tailor";
    el.textContent = text;
    $log.appendChild(el);
    scrollLog();
  }

  function userSay(text, image) {
    const el = document.createElement("div");
    el.className = "jod-msg jod-msg--user";
    if (text) el.textContent = text;
    if (image) {
      const img = document.createElement("img");
      img.src = image;
      el.appendChild(img);
    }
    $log.appendChild(el);
    scrollLog();
  }

  function showTyping() {
    const el = document.createElement("div");
    el.className = "jod-msg jod-msg--tailor";
    el.innerHTML = '<div class="jod-typing"><span></span><span></span><span></span></div>';
    $log.appendChild(el);
    scrollLog();
    return el;
  }

  function scrollLog() { $log.scrollTop = $log.scrollHeight; }

  function updateSpec(partial) {
    Object.assign(state.spec, partial);
    $specList.innerHTML = "";
    SPEC_FIELDS.forEach(({ key, label }) => {
      if (!state.spec[key]) return;
      const row = document.createElement("div");
      row.className = "jod-receipt__row";
      row.innerHTML = `<dt>${label}</dt><dd>${escapeHtml(state.spec[key])}</dd>`;
      $specList.appendChild(row);
    });
    if ($specPlaceholder) {
      $specPlaceholder.hidden = $specList.children.length > 0;
    }
    const hasMinimum = state.spec.style && state.spec.material && state.spec.color;
    if (hasMinimum) {
      $openMeasure.hidden = false;
      if ($whatsapp) $whatsapp.hidden = false;
    }
  }

  // WhatsApp handoff: pre-fills the chat with the current spec
  if ($whatsapp) {
    $whatsapp.addEventListener("click", (e) => {
      e.preventDefault();
      const number = ($whatsapp.dataset.jodWaNumber || "").replace(/[^0-9]/g, "");
      if (!number) return;
      const intro = $whatsapp.dataset.jodWaIntro ||
        "Hi! I started designing a custom jacket on jacketondemand.com.";
      const lines = [intro, "", "Here's what I have so far:"];
      SPEC_FIELDS.forEach(({ key, label }) => {
        if (state.spec[key]) lines.push(`• ${label}: ${state.spec[key]}`);
      });
      if (state.mockupUrl) {
        lines.push("");
        lines.push(`Mockup: ${state.mockupUrl}`);
      }
      lines.push("");
      lines.push("Could we continue from here?");
      const url = `https://wa.me/${number}?text=${encodeURIComponent(lines.join("\n"))}`;
      window.open(url, "_blank", "noopener");
    });
  }

  function setMockup(url) {
    state.mockupUrl = url;
    state.mockups = state.mockups || [];
    state.mockups.push(url);

    // Remove placeholder on first sketch
    const placeholder = $mockupStack.querySelector(".jod-sketches__placeholder");
    if (placeholder) placeholder.remove();

    const sketch = document.createElement("figure");
    sketch.className = "jod-sketch";
    const img = document.createElement("img");
    img.src = url;
    img.alt = `Sketch v${state.mockups.length} of your custom jacket`;
    img.loading = "lazy";
    const caption = document.createElement("figcaption");
    caption.className = "jod-sketch__caption";
    caption.textContent = `sketch v${state.mockups.length}`;
    sketch.appendChild(img);
    sketch.appendChild(caption);
    // Newest sketch on top of the pinboard
    $mockupStack.prepend(sketch);
  }

  function maybeEnableCart() {
    const required = ["style", "material", "color"];
    const ready = required.every((k) => state.spec[k]);
    $addToCart.disabled = !ready;
  }

  // ============================================================
  // MEASUREMENT FLOW
  // ============================================================
  const $measure        = root.querySelector("[data-jod-measure]");
  const $figure         = root.querySelector("[data-jod-figure]");
  const $stepCounter    = root.querySelector("[data-jod-step-counter]");
  const $stepTitle      = root.querySelector("[data-jod-step-title]");
  const $stepDesc       = root.querySelector("[data-jod-step-desc]");
  const $stepInput      = root.querySelector("[data-jod-step-input]");
  const $stepUnit       = root.querySelector("[data-jod-step-unit]");
  const $summary        = root.querySelector("[data-jod-summary]");
  const $summaryList    = root.querySelector("[data-jod-summary-list]");
  const $sizeRec        = root.querySelector("[data-jod-size-rec]");
  const $unitButtons    = root.querySelectorAll("[data-jod-unit]");

  const MEASURE_STEPS = [
    {
      key: "chest",
      title: "Chest",
      desc: "Around the fullest part of your chest, under the armpits. Keep the tape level and snug, not tight.",
      highlight: "chest",
    },
    {
      key: "shoulder",
      title: "Shoulder width",
      desc: "Across your back, from the outer edge of one shoulder to the other.",
      highlight: "shoulder",
    },
    {
      key: "sleeve",
      title: "Sleeve length",
      desc: "From the tip of your shoulder, down a slightly bent arm, to your wrist bone.",
      highlight: "sleeve",
    },
    {
      key: "length",
      title: "Jacket length",
      desc: "From the base of your neck (back) down to where you want the jacket to end.",
      highlight: "length",
    },
    {
      key: "waist",
      title: "Waist",
      desc: "Around your natural waist, roughly an inch above the navel. For fitted styles only.",
      highlight: "waist",
    },
  ];

  const measureState = {
    unit: "cm",
    stepIndex: 0,
    values: {}, // values stored in cm internally
  };

  function openMeasurements() {
    measureState.stepIndex = 0;
    measureState.values = {};
    $summary.hidden = true;
    document.querySelector("[data-jod-step]")?.removeAttribute("hidden");
    $measure.hidden = false;
    document.body.style.overflow = "hidden";
    renderMeasureStep();
    setTimeout(() => $stepInput.focus(), 100);
  }

  function closeMeasurements() {
    $measure.hidden = true;
    document.body.style.overflow = "";
  }

  $openMeasure.addEventListener("click", openMeasurements);
  root.querySelectorAll('[data-jod-action="close-measurements"]').forEach(btn =>
    btn.addEventListener("click", closeMeasurements)
  );

  $unitButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const unit = btn.dataset.jodUnit;
      if (unit === measureState.unit) return;
      measureState.unit = unit;
      $unitButtons.forEach(b => b.classList.toggle("is-active", b === btn));
      $stepUnit.textContent = unit;
      const cur = MEASURE_STEPS[measureState.stepIndex];
      if (measureState.values[cur.key] != null) {
        $stepInput.value = formatValue(measureState.values[cur.key], unit);
      }
    });
  });

  root.querySelector('[data-jod-action="measure-next"]').addEventListener("click", () => {
    const step = MEASURE_STEPS[measureState.stepIndex];
    const raw = parseFloat($stepInput.value);
    if (!isFinite(raw) || raw <= 0) {
      $stepInput.focus();
      $stepInput.classList.add("is-invalid");
      setTimeout(() => $stepInput.classList.remove("is-invalid"), 600);
      return;
    }
    measureState.values[step.key] = measureState.unit === "in" ? raw * 2.54 : raw;

    if (measureState.stepIndex >= MEASURE_STEPS.length - 1) {
      renderSummary();
    } else {
      measureState.stepIndex++;
      renderMeasureStep();
    }
  });

  root.querySelector('[data-jod-action="measure-prev"]').addEventListener("click", () => {
    if (measureState.stepIndex === 0) {
      closeMeasurements();
      return;
    }
    measureState.stepIndex--;
    renderMeasureStep();
  });

  root.querySelector('[data-jod-action="measure-restart"]').addEventListener("click", () => {
    measureState.stepIndex = 0;
    $summary.hidden = true;
    renderMeasureStep();
  });

  root.querySelector('[data-jod-action="measure-confirm"]').addEventListener("click", () => {
    const summary = MEASURE_STEPS
      .filter(s => measureState.values[s.key] != null)
      .map(s => `${s.title}: ${measureState.values[s.key].toFixed(1)} cm`)
      .join(" · ");
    const size = recommendSize(measureState.values);
    updateSpec({ size, measurements: summary });
    closeMeasurements();
    tailorSay(
      `Measurements logged. We'll cut to a recommended ${size}. ` +
      `Add to cart whenever you're ready — our team will confirm everything by email before we cut a single panel.`
    );
    state.history.push({ role: "assistant", content: `Measurements confirmed: ${summary}. Size: ${size}.` });
  });

  function renderMeasureStep() {
    const step = MEASURE_STEPS[measureState.stepIndex];
    $summary.hidden = true;
    $stepCounter.textContent = `Step ${measureState.stepIndex + 1} of ${MEASURE_STEPS.length}`;
    $stepTitle.textContent = step.title;
    $stepDesc.textContent = step.desc;
    $stepUnit.textContent = measureState.unit;
    const existing = measureState.values[step.key];
    $stepInput.value = existing != null ? formatValue(existing, measureState.unit) : "";
    $stepInput.placeholder = measureState.unit === "cm" ? "e.g. 102" : "e.g. 40";
    renderFigure(step.highlight);
    $stepInput.focus();
  }

  function renderSummary() {
    $summary.hidden = false;
    $summaryList.innerHTML = "";
    MEASURE_STEPS.forEach(step => {
      const v = measureState.values[step.key];
      if (v == null) return;
      const row = document.createElement("div");
      row.className = "jod-measure__summary-row";
      row.innerHTML = `<dt>${step.title}</dt><dd>${formatValue(v, measureState.unit)} ${measureState.unit}</dd>`;
      $summaryList.appendChild(row);
    });
    $sizeRec.textContent = recommendSize(measureState.values);
  }

  function formatValue(cm, unit) {
    if (unit === "in") return (cm / 2.54).toFixed(1);
    return cm.toFixed(1);
  }

  function recommendSize({ chest }) {
    // Rough guidance; refine against your atelier's grading sheet.
    if (!chest) return "—";
    if (chest < 92)   return "XS";
    if (chest < 100)  return "S";
    if (chest < 108)  return "M";
    if (chest < 116)  return "L";
    if (chest < 124)  return "XL";
    return "XXL";
  }

  function renderFigure(highlight) {
    // Simple line-drawn torso/arms with the active measurement highlighted.
    const accent = "#c9a86a";
    const ink    = "rgba(244,236,223,0.55)";
    const hl = (k) => highlight === k ? accent : ink;
    const hlW = (k) => highlight === k ? 2.5 : 1.2;
    $figure.innerHTML = `
      <svg viewBox="0 0 220 320" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <!-- head -->
        <circle cx="110" cy="38" r="22" fill="none" stroke="${ink}" stroke-width="1.2"/>
        <!-- neck -->
        <path d="M100 60 L100 76 L120 76 L120 60" fill="none" stroke="${ink}" stroke-width="1.2"/>
        <!-- shoulders + torso -->
        <path d="M55 92 Q70 78 100 76 L120 76 Q150 78 165 92 L172 200 L150 230 L70 230 L48 200 Z"
              fill="none" stroke="${ink}" stroke-width="1.2"/>
        <!-- arms -->
        <path d="M55 92 L40 200 L52 232" fill="none" stroke="${ink}" stroke-width="1.2"/>
        <path d="M165 92 L180 200 L168 232" fill="none" stroke="${ink}" stroke-width="1.2"/>

        <!-- highlight overlays -->
        <line x1="55" y1="92" x2="165" y2="92" stroke="${hl('shoulder')}" stroke-width="${hlW('shoulder')}" stroke-dasharray="${highlight==='shoulder'?'0':'4 4'}"/>
        <path d="M52 130 Q110 120 168 130" fill="none" stroke="${hl('chest')}" stroke-width="${hlW('chest')}" stroke-dasharray="${highlight==='chest'?'0':'4 4'}"/>
        <path d="M58 175 Q110 168 162 175" fill="none" stroke="${hl('waist')}" stroke-width="${hlW('waist')}" stroke-dasharray="${highlight==='waist'?'0':'4 4'}"/>
        <path d="M165 92 L180 200 L168 232" fill="none" stroke="${hl('sleeve')}" stroke-width="${hlW('sleeve')}"/>
        <line x1="110" y1="76" x2="110" y2="230" stroke="${hl('length')}" stroke-width="${hlW('length')}" stroke-dasharray="${highlight==='length'?'0':'4 4'}"/>
      </svg>
    `;
  }

  // ---- Shopify cart handoff ----
  $addToCart.addEventListener("click", async () => {
    $addToCart.disabled = true;
    $addToCart.textContent = "Adding…";
    try {
      const properties = {};
      SPEC_FIELDS.forEach(({ key, label }) => {
        if (state.spec[key]) properties[label] = state.spec[key];
      });
      if (state.mockupUrl) properties["Mockup"] = state.mockupUrl;

      const productRes = await fetch(`/products/${productHandle}.js`);
      if (!productRes.ok) throw new Error("Product not found. Check section settings.");
      const product = await productRes.json();
      const variantId = product.variants[0].id;

      const addRes = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1, properties }),
      });
      if (!addRes.ok) throw new Error("Add to cart failed.");
      window.location.href = "/cart";
    } catch (err) {
      console.error("[tailor]", err);
      $addToCart.disabled = false;
      $addToCart.textContent = "Add to cart";
      tailorSay("Hmm — I couldn't add it just now. Please try again, or refresh the page.");
    }
  });

  // ---- utils ----
  function sleep(ms) { return new Promise(r => setTimeout(r, ms)); }
  function fileToDataUrl(file) {
    return new Promise((resolve, reject) => {
      const r = new FileReader();
      r.onload = () => resolve(r.result);
      r.onerror = reject;
      r.readAsDataURL(file);
    });
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({
      "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;"
    })[c]);
  }
})();
